import { render, staticRenderFns } from "./RecipeInfo.vue?vue&type=template&id=5309707c&scoped=true&"
import script from "./RecipeInfo.vue?vue&type=script&lang=js&"
export * from "./RecipeInfo.vue?vue&type=script&lang=js&"
import style0 from "./RecipeInfo.vue?vue&type=style&index=0&id=5309707c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309707c",
  null
  
)

export default component.exports